enum PatientAcceptanceLimitationEnum {
  None = "None",
  ThroughReferral = "through_referral",
  ThroughHospitalFacility = "through_hospital_facility",
  CompanyEmployees = "company_employees",
  FamilyOfExistingMember = "family_of_existing_member",
}

export { PatientAcceptanceLimitationEnum };
